export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref9986.5cc67ed0.jpg";